import { render } from "./TtnTMS.vue?vue&type=template&id=f65c1176&scoped=true&ts=true"
import script from "./TtnTMS.vue?vue&type=script&lang=ts"
export * from "./TtnTMS.vue?vue&type=script&lang=ts"

import "./TtnTMS.vue?vue&type=style&index=0&id=f65c1176&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f65c1176"]])

export default __exports__